import React, { useState, useEffect } from "react";
import { Button, Menu, Modal, Checkbox } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setModalJuryPostulate } from "../../../redux/actions/juradosAction";
import { IModalProps } from "../InterfaceProp";
import axios from "axios";
const { SubMenu } = Menu;

const ModalJuryPostulate = ({ getIdPostularJurado }: IModalProps) => {
  
  const [filter, setFilter] = React.useState([]);
  const [checkValue, setCheckValue] = useState<any>([]);
  const [array, setArray] = useState<any>({
    Medellínvivelasartes: [],
    FestivaldeTango: [],
    FestivalAltavoz: [],
    Estímulosalacreatividadenelespaciopublico: [],
    Estímuloalaapropiacióncreativadenuestropatrimoniovivo: [],
    Estímulosparalapromociónydistribucióndelargometrajesycortometrajes: [],
  });


  

  /**
   * Lines state
   */
  const [lines, setLines] = useState<any>([])

  const filtroMultiple = async () => {
    let response = await axios.get(`${process.env.REACT_APP_SERVER_JURA2}lines/`);

    setFilter(response.data.lines);
  };
  const postLinesCategory = async(e:any)=> {
    e.preventDefault()
  };

  useEffect(() => {
    filtroMultiple();
  }, []);

  const dispatch = useDispatch();

  const changeButtom = () => {
    dispatch(setModalJuryPostulate(false));
  };

  const changeButtomPostulate = (e:any) =>{
    getIdPostularJurado()
    postLinesCategory(e)
    dispatch(setModalJuryPostulate(false));
  }
  const style = {
    divCheck: {
      marginLeft: "20px",
      height: "30px",
    },
    divContainer: {
      border: "solid 0.1px #DCDCDC",
      marginTop: "25px",
      borderRadius: "10px",
    },
    divContainerP: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    title: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
  };
  const modalOpen = useSelector(
    (state: { jurado: { setModalJuryPostulate: boolean } }) =>
      state.jurado.setModalJuryPostulate
  );

  /**
   * Receives the event to get the line and
   * category id, and store it on the lines state.
   *
   * Also changes the selected categories count.
   * 
   * @param e event
   * @returns {Void}
   */
  function onChange(e: any) {
    
    let categoryId = e.target.value.id
    let lineId = e.target.value.line_id
    const name = e.target.name.name.split(" ").join("");

    if(e.target.checked) {
      let searchLine: any = lines.find((line: any) => line.id == lineId)

      setArray({
        ...array,
        
        [name]: [...array[name], e.target.value],
      });
      setCheckValue([...checkValue, categoryId]);

      if(searchLine === undefined) {
        let line: any = {
          id: lineId,
          categories: [categoryId]
        }
        
        lines && lines.length > 0
          ? setLines([...lines, line])
          : setLines([line])
        return
      }

      searchLine.categories.push(categoryId)

      let updatedLines: any = lines.filter((line: any) => line.id !== lineId)
      updatedLines.push(searchLine)
      
      setLines(updatedLines)
      setCheckValue([...checkValue, categoryId]);
    }

    if(!e.target.checked) {
      let lineToUpdate: any = lines.find((line: any) => line.id == lineId)
    
      let newCategories = lineToUpdate.categories.filter((category: any) => category != categoryId)

      lineToUpdate.categories = newCategories

      if(lineToUpdate.categories && lineToUpdate.categories.length === 0) {
        let newLines: any = lines.filter((line: any) => line.id !== lineId)
        setLines(newLines)
        return
      }

      let updatedLines: any = lines.filter((line: any) => line.id !== lineId)
      updatedLines.push(lineToUpdate)

      setLines(updatedLines)

      const newArray = array[name].filter((element: any) => categoryId !== element.id);
      setArray({
        ...array,
        [name]: newArray,
      });

      const newValue = checkValue.filter((element: any) => categoryId !== element);
      setCheckValue(newValue);
    }
  }
  


  return (
    <Modal
      visible={modalOpen}
      width={1012}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={changeButtom} className="button-blanco-radius">
            Cerrar
          </Button>
          <Button
            className="button-azul-radius"
            onClick={changeButtomPostulate}
          >
            Finalizar Postulacion de Jurado
          </Button>
        </div>
      }
    >
      <div className="div">
        <div className="div" style={style.divContainer}>
          <div style={style.divContainerP}>
            <div
              style={{
                background: "white",
                position: "relative",
                top: -10,
              }}
            >
              <p>Seleciona las categorias del jurado a evaluar</p>
            </div>
          </div>

          {filter && filter.length >= 1
            ? filter.map((value: any, index: number) => (
                <Menu
                  key={value.id || value.key || value.titulo}
                  mode="inline"
                  className="menu"
                  style={{ marginBottom: "10px", borderRadius: "10px" }}
                >
                  <SubMenu
                    title={
                      <div style={style.title}>
                        <h3 style={{ margin: 0 }}>{value.name}</h3>{" "}
                        <span style={{ color: "orange" }}>
                          Seleccionados(
                          {array[value.name.split(" ").join("")].length})
                        </span>
                      </div>
                    }
                  >
                    {value.categories && value.categories.length >= 1
                      ? value.categories.map((category: any, i: number) => {
                          return (
                            <div
                              style={style.divCheck}
                              key={i + category.name}
                            >
                              <Checkbox
                                value={category}
                                name={value}
                                onChange={onChange}
                              >
                                {category.name}
                              </Checkbox>
                            </div>
                          );
                        })
                      : null}
                  </SubMenu>
                </Menu>
              ))
            : null}
        </div>
      </div>
    </Modal>
  );
};

ModalJuryPostulate.propTypes = {};

export default ModalJuryPostulate;
